import { forwardRef, type AnchorHTMLAttributes } from "react";
import { Link } from "react-router";

/** Lets Astryx Link/Button/ListItem `href` navigate client-side through React Router. */
export const RouterLink = forwardRef<HTMLAnchorElement, AnchorHTMLAttributes<HTMLAnchorElement> & { href?: string }>(
  function RouterLink({ href = "", ...rest }, ref) {
    const external = /^(https?:|mailto:|tel:)/.test(href) || rest.target === "_blank" || rest.download !== undefined;
    if (external) return <a ref={ref} href={href} {...rest} />;
    return <Link ref={ref} to={href} {...rest} />;
  },
);
